import API_BASE_URL from "../config";

export async function initAuth() {
  try {
    const res = await fetch(`${API_BASE_URL}/refresh`, {
      method: "POST",
      credentials: "include",
    });

    if (!res.ok) {
      window.accessToken = null;
      return false;
    }

    const data = await res.json();
    window.accessToken = data.access_token;
    return true;
  } catch (err) {
    return false;
  }
}
